/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import {
  clearBillingEmailFormErrors,
  selectBillingEmailFormError,
  updateBillingEmail,
} from '../../../../redux/slices/billingSlice/billingSlice';

function BillingEmailModal({
  show,
  handleClose,
  initialEmail,
}) {
  const dispatch = useDispatch();
  const formError = useSelector(selectBillingEmailFormError);

  const [submitting, setSubmitting] = useState(false);
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (!show) return;

    setEmail(initialEmail || '');

    dispatch(clearBillingEmailFormErrors());
  }, [show, initialEmail, dispatch]);

  const handleSubmit = async () => {
    if (!email) return;
    setSubmitting(true);
    try {
      await dispatch(updateBillingEmail({ billingEmail: email })).unwrap();
      setSubmitting(false);
      handleClose();
      window.location.reload();
    } catch (err) {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="md" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Billing Email Address</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="text-muted">
          Billing and account status related messages will be sent to this address.
        </p>

        {formError && (
          <div className="alert alert-danger">
            {formError}
          </div>
        )}

        <label className="font-weight-bold">
          Billing Email Address
        </label>

        <input
          type="email"
          className="form-control"
          placeholder="Enter billing email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={submitting}
        >
          {submitting ? 'Saving...' : 'Save'}
        </button>

        <button
          type="button"
          className="btn btn-link"
          onClick={handleClose}
        >
          cancel
        </button>
      </Modal.Footer>
    </Modal>
  );
}

BillingEmailModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  initialEmail: PropTypes.string,
};

BillingEmailModal.defaultProps = {
  initialEmail: '',
};

export default BillingEmailModal;
